import React, { useState, forwardRef, useEffect } from "react";
import { Link, useHistory } from 'react-router-dom';
import MaterialTable from "material-table";
import { Dropdown, Modal } from 'react-bootstrap';
import { Search, ViewColumn, SaveAlt, Remove, LastPage, FirstPage, FilterList, Edit, DeleteOutline, Clear, ChevronRight, ChevronLeft, Check, ArrowDownward, AddBox } from '@material-ui/icons';

import btcicon from "../../../icons/crypto/btc.svg";
import ethicon from "../../../icons/crypto/eth.svg";
import usdticon from "../../../icons/crypto/usdt.svg";
import usdcicon from "../../../icons/crypto/usdc.svg";
import avarta from "../../../images/avatar/1.png";

import { useTranslation } from "react-i18next";
import Loader from '../../pages/Loader';
import axios from 'axios';
import moment from 'moment';

import { CsvBuilder } from 'filefy';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { checkauhtoken } from '../../../api/PrePageLoad';
import { formatBalance } from "../../../utils";

const materialTableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


export const Crypto_Transactions = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const [loader, setLoader] = useState(false);

    const [original_deposit_array, setoriginal_deposit_array] = useState([]);
    const [original_withdraw_array, setoriginal_withdraw_array] = useState([]);
    const [original_transfer_array, setoriginal_transfer_array] = useState([]);
    const [original_exchange_array, setoriginal_exchange_array] = useState([]);
    const [original_swap_array, setoriginal_swap_array] = useState([]);

    const [original_depositaddress_array, setoriginal_depositaddress_array] = useState([]);
    const [original_withdrawaddress_array, setoriginal_withdrawaddress_array] = useState([]);
    const [from_date, setfrom_date] = useState("");
    const [to_date, setto_date] = useState("");

    const [temp_deposit_array, settemp_deposit_array] = useState([]);
    const [temp_withdraw_array, settemp_withdraw_array] = useState([]);
    const [temp_transfer_array, settemp_transfer_array] = useState([]);
    const [temp_exchange_array, settemp_exchange_array] = useState([]);
    const [temp_swap_array, settemp_swap_array] = useState([]);
    const [temp_depositaddress_array, settemp_depositaddress_array] = useState([]);
    const [temp_withdrawaddress_array, settemp_withdrawaddress_array] = useState([]);

    const [TransactionType, setTransactionType] = useState("CryptoExchange");
    const handleChangeTransactionType = (TransactionTypeVal) => {
        // Clear all selections when changing transaction type
        setSelectedExchangeRows([]);
        setSelectedWithdrawRows([]);
        setSelectedSwapRows([]);
        setSelectedDepositRows([]);
        setSelectedTransferRows([]);
        setSelectedDepositAddressRows([]);
        setSelectedWithdrawAddressRows([]);
        
        setTransactionType(TransactionTypeVal);
        document.getElementById("CryptoExchange").style.display = "none";
        document.getElementById("Deposit").style.display = "none";
        document.getElementById("Withdrawal").style.display = "none";
        document.getElementById("Transfer").style.display = "none";
        document.getElementById("Swap").style.display = "none";
        document.getElementById("Depositaddress").style.display = "none";
        document.getElementById("Withdrawaddress").style.display = "none";
        document.getElementById(TransactionTypeVal).style.display = "block";
    }


    const handleChangeCSVNdPDF = (val) => {
        let FileName = "Transactions";
        let FileData;
        let dataToUse;
        let columns = [];

        if (TransactionType === "CryptoExchange") {
            FileName = "CryptoExchange";
            // Use selected rows if any, otherwise use all data
            dataToUse = selectedExchangeRows.length > 0 ? selectedExchangeRows : original_exchange_array;
            columns = [
                { title: t("TRANSACTION.TRA_ID"), field: 'transaction_hash', },
                { title: t("TRANSACTION.DATE_LA"), field: 'created_datetime' },
                { title: t("TRANSACTION.TYPE"), field: 'exchange_type' },
                { title: t("TRANSACTION.PAIR"), field: 'exchnage_pair', },
                { title: "Site Fee", field: 'fee', },
                { title: t("TRANSACTION.FIAT_AMOUNT"), field: 'fiat_amount' },
                { title: "Crypto Amount", field: 'crypto_amount' },
                { title: t("TRANSACTION.STATUS_LA"), field: 'transfer_status' },
            ];

            FileData = dataToUse.map(rowData =>
                [rowData["transaction_hash"],
                rowData["created_datetime"],
                rowData["exchange_type"],
                rowData["exchnage_pair"],
                rowData["fee"],
                rowData["fiat_amount"],
                rowData["crypto_amount"],
                rowData["StatusText"]]
            );

        } else if (TransactionType === "Deposit") {
            FileName = "Deposit";
            // Use selected rows if any, otherwise use all data
            dataToUse = selectedDepositRows.length > 0 ? selectedDepositRows : original_deposit_array;
            columns = [
                { title: t("TRANSACTION.DATE_LA"), field: 'date' },
                { title: t("CRYPTOTRANSACTION.COINCODE"), field: 'currancy' },
                { title: t("CRYPTOTRANSACTION.TRAHASH"), field: 'transactionid' },
                { title: t("TRANSACTION.AMOUNT"), field: 'amount' },
                { title: t("TRANSACTION.STATUS_LA"), field: 'status', align: 'center' }
            ];

            FileData = dataToUse.map(rowData =>
                [rowData["date"],
                rowData["currancy"],
                rowData["transactionid"],
                rowData["amount"],
                rowData["StatusText"]]
            );
        } else if (TransactionType === "Depositaddress") {
            FileName = "Deposit Address";
            // Use selected rows if any, otherwise use all data
            dataToUse = selectedDepositAddressRows.length > 0 ? selectedDepositAddressRows : original_depositaddress_array;
            columns = [
                { title: 'Date', field: 'date', },
                { title: 'Account Number', field: 'Accountno' },
                { title: 'Wallet Address', field: 'WalletAddress' },
                { title: 'Status', field: 'Status', align: 'center' },
            ]

            FileData = dataToUse.map(rowData =>
                [rowData["date"],
                rowData["Accountno"],
                rowData["WalletAddress"],
                rowData["StatusText"]]
            );
        } else if (TransactionType === "Withdrawaddress") {
            FileName = "Withdraw Address";
            // Use selected rows if any, otherwise use all data
            dataToUse = selectedWithdrawAddressRows.length > 0 ? selectedWithdrawAddressRows : original_withdrawaddress_array;
            columns = [
                { title: 'Date', field: 'date', },
                { title: 'Account Number', field: 'Accountno' },
                { title: 'Wallet Address', field: 'WalletAddress' },
                { title: 'Status', field: 'Status', align: 'center' },
            ]

            FileData = dataToUse.map(rowData =>
                [rowData["date"],
                rowData["Accountno"],
                rowData["WalletAddress"],
                rowData["StatusText"]]
            );
        } else if (TransactionType === "Withdrawal") {
            FileName = "Withdrawal";
            // Use selected rows if any, otherwise use all data
            dataToUse = selectedWithdrawRows.length > 0 ? selectedWithdrawRows : original_withdraw_array;
            columns = [
                { title: t("TRANSACTION.DATE_LA"), field: 'date' },
                { title: t("CRYPTOTRANSACTION.COINCODE"), field: 'currancy' },
                { title: t("CRYPTOTRANSACTION.TRAHASH"), field: 'transactionid' },
                { title: t("TRANSACTION.AMOUNT"), field: 'amount' },
                { title: "Order Amount", field: 'debitAmount' },
                { title: "Site Fee", field: 'fees' },
                { title: t("TRANSACTION.STATUS_LA"), field: 'status', align: 'center' }
            ];

            FileData = dataToUse.map(rowData =>
                [rowData["date"],
                rowData["coincode"],
                rowData["transactionid"],
                rowData["amount"],
                rowData["debitAmount"],
                rowData["fees"],
                rowData["StatusText"]]
            );
        } else if (TransactionType === "Transfer") {
            FileName = "Transfer";
            // Use selected rows if any, otherwise use all data
            dataToUse = selectedTransferRows.length > 0 ? selectedTransferRows : original_transfer_array;
            columns = [
                { title: t("TRANSACTION.USERNAME"), field: 'userdiv' },
                { title: t("CRYPTOTRANSACTION.TRAHASH"), field: 'transactionid' },
                { title: t("TRANSACTION.DATE_LA"), field: 'date' },
                { title: t("CRYPTOTRANSACTION.COINCODE"), field: 'currancy' },
                { title: t("TRANSACTION.AMOUNT"), field: 'amount' }
            ];


            FileData = dataToUse.map(rowData =>
                [rowData["CusName"],
                rowData["transactionid"],
                rowData["date"],
                rowData["coincode"],
                rowData["amount"]]
            );
        } else if (TransactionType === "Swap") {
            FileName = "Swap";
            // Use selected rows if any, otherwise use all data
            dataToUse = selectedSwapRows.length > 0 ? selectedSwapRows : original_swap_array;
            columns = [
                { title: t("TRANSACTION.TRA_ID"), field: 'transaction_hash', },
                { title: t("TRANSACTION.DATE_LA"), field: 'created_datetime' },
                { title: t("FIAT.FROM_AMOUNT"), field: 'from_amount' },
                // { title: t("FIAT.FROM"), field: 'from_coin' },
                { title: t("FIAT.TO_AMOUNT"), field: 'to_amount' },
                { title: "Site Fee", field: 'Fees' },
                // { title: t("FIAT.TO"), field: 'to_coin' },
                { title: t("TRANSACTION.STATUS_LA"), field: 'swap_status' },
            ];

            FileData = dataToUse.map(rowData =>
                [rowData["transaction_hash"],
                rowData["created_datetime"],
                rowData["from_amount"],
                // rowData["from_coincode"],
                rowData["to_amount"],
                rowData["Fees"],
                // rowData["to_coincode"],
                rowData["StatusText"]]
            );
        }


        const columnTitles = columns.map(columnDef => columnDef.title);



        if (val === "CSV") {
            const builder = new CsvBuilder(FileName + `.csv`)
                .setColumns(columnTitles)
                .addRows(FileData)
                .exportFile();

            return builder;
        }
        else if (val === "PDF") {
            const doc = new jsPDF();

            doc.autoTable({
                head: [columnTitles],
                body: FileData,
            });

            doc.save(FileName + `.pdf`);
        }
    }

    const viewdeposit = (val) => {
        console.log(val.deposit_address_id);
        window.sessionStorage.setItem("depoidfk", val.deposit_address_id);
        history.push('/wallets-deposit-transaction');
    }

    const viewwithdraw = (val) => {
        console.log(val)
        window.localStorage.setItem("cypto_wallet_id", val.user_crypto_wallets_crypto_fk);
        window.localStorage.setItem("account_id", val.account_id);
        window.localStorage.setItem("withaddress", val.wallet_address);
        setTimeout(() => {
            history.push('/wallets-withdrawal-transaction');
        }, 1000);
    }

    useEffect(() => {
        checkauhtoken();
        handleLoad();
    }, []);

    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [open, setOpen] = useState(false);

    const handleOpenPopup = (element) => {
        setSelectedTransaction(element);
        setOpen(true);
    };
    const handleClosePopup = () => {
        setSelectedTransaction(null);
        setOpen(false);
    };


    const handleLoad = () => {
      
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.get(process.env.REACT_APP_API_URL + 'cryptoexchange/GetAllCryptoTransaction', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setLoader(false);
                    settemp_transfer_array(res.data.transfer_array);
                    settemp_withdraw_array(res.data.withdrawtransaction);
                    settemp_exchange_array(res.data.buyselltra);
                    settemp_swap_array(res.data.swaptra);
                    settemp_deposit_array(res.data.deposittransaction);
                    settemp_depositaddress_array(res.data.depoaddress);
                    settemp_withdrawaddress_array(res.data.withaddress);
                    if (res.data.transfer_array.length > 0) {
                        let TempArrfiat = [];
                        res.data.transfer_array.forEach(element => {

                            let currancy = "";
                            let amount = "";

                            let userdiv = <div><div className="mb-lg-0 mb-3 d-flex align-items-center"><div className="profile-image mr-4"><img src={avarta} alt="" width="63" className="rounded-circle" /></div><div><h6 className="fs-16 font-w700 mb-0"><Link to="#" className="text-black"> {element.first_name + '' + element.last_name}</Link></h6><span className="fs-14">{element.email_id}</span></div></div></div>
                            if (element.image_64 !== "" && element.image_64 !== null) {
                                userdiv = <div><div className="mb-lg-0 mb-3 d-flex align-items-center"><div className="profile-image mr-4"><img src={process.env.REACT_APP_FILE_PATH + element.image_64} alt="" width="63" className="rounded-circle" /></div><div><h6 className="fs-16 font-w700 mb-0"><Link to="#" className="text-black"> {element.first_name + ' ' + element.last_name}</Link></h6><span className="fs-14">{element.email_id}</span></div></div></div>
                            }
                            if (element.coin_code === "BTC") {
                                currancy = <div><img alt="" src={btcicon} className="coin-img" /></div>;
                                amount = element.transfer_amount + " BTC";
                            } else if (element.coin_code === "ETH") {
                                currancy = <div><img alt="" src={ethicon} className="coin-img" /></div>;
                                amount = element.transfer_amount + " ETH";
                            } else if (element.coin_code === "USDT") {
                                currancy = <div><img alt="" src={usdticon} className="coin-img" /></div>;
                                amount = element.transfer_amount + " USDT";
                            } else if (element.coin_code === "USDC") {
                                currancy = <div><img alt="" src={usdcicon} className="coin-img" /></div>;
                                amount = element.transfer_amount + " USDC";
                            }

                            let fiatonetemp = {
                                userdiv: userdiv,
                                transactionid: element.transaction_hash,
                                date: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                                currancy: currancy,
                                amount: formatBalance(amount),
                                CusName: element.first_name + '' + element.last_name,
                                coincode: element.coin_code,
                                transfer_id: element.transfer_id
                            };
                            TempArrfiat.push(fiatonetemp);

                        });
                        setoriginal_transfer_array(TempArrfiat);
                    }


                    if (res.data.deposittransaction.length > 0) {
                        let TempArrwith = [];
                        res.data.deposittransaction.forEach(element => {

                            let currancy = "";
                            let amount = "";
                            let status = "";

                            if (element.coin_code === "BTC") {
                                currancy = <div><img alt="" src={btcicon} className="coin-img" /></div>;
                                amount = element.fund_amount ;
                            } else if (element.coin_code === "ETH") {
                                currancy = <div><img alt="" src={ethicon} className="coin-img" /></div>;
                                amount = element.fund_amount ;
                            } else if (element.coin_code === "USDT") {
                                currancy = <div><img alt="" src={usdticon} className="coin-img" /></div>;
                                amount = element.fund_amount ;
                            } else if (element.coin_code === "USDC") {
                                currancy = <div><img alt="" src={usdcicon} className="coin-img" /></div>;
                                amount = element.fund_amount ;
                            }

                            if (element.withdraw_status === "Completed") {
                                status = <div><button className="btn btn-outline-success btn-rounded">Success</button></div>
                            } else if (element.withdraw_status === "Failed") {
                                status = <div><button className="btn btn-outline-danger btn-rounded">Failed</button></div>
                            } else {
                                status = <div><button className="btn btn-outline-warning btn-rounded">Pending</button></div>
                            }


                            let withtemp = {
                                date: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                                currancy: currancy,
                                transactionid: element.transaction_hash,
                                amount: formatBalance(amount) +" "+ element.coin_code,
                                status: status,
                                StatusText: element.withdraw_status,
                                depositfund_id: element.depositfund_id
                            };
                            TempArrwith.push(withtemp);

                        });
                        setoriginal_deposit_array(TempArrwith);
                    }

                    if (res.data.depoaddress.length > 0) {
                        let TempArrwith = [];
                        res.data.depoaddress.forEach(element => {

                            let status;
                            if (element.status === "Approved") {
                                status = <div><button className="btn btn-outline-warning btn-rounded">Inactive</button></div>
                            } else {
                                status = <div><button className="btn btn-outline-success btn-rounded">Active</button></div>
                            }

                            let depoaddress = {
                                date: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                                Accountno: element.user_acc_account_number,
                                WalletAddress: element.wallet_address,
                                Status: status,
                                Action: <Link to="#" onClick={() => viewdeposit(element)} className="btn btn-light btn-rounded btn-xs" title="View"><i className="fa fa-eye f-18"></i></Link>,
                                StatusText: element.status,
                                deposit_address_id: element.deposit_address_id
                            };
                            TempArrwith.push(depoaddress);

                        });
                        setoriginal_depositaddress_array(TempArrwith);
                    }


                    if (res.data.withaddress.length > 0) {
                        let TempArrwith = [];
                        res.data.withaddress.forEach(element => {

                            let status = <div><button className="btn btn-outline-warning btn-rounded">Inactive</button></div>

                            let withaddress = {
                                date: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                                Accountno: element.user_acc_account_number,
                                WalletAddress: element.wallet_address,
                                Status: status,
                                StatusText: "Inactive",
                                Action: <Link to="#" onClick={() => viewwithdraw(element)} className="btn btn-light btn-rounded btn-xs" title="View"><i className="fa fa-eye f-18"></i></Link>,
                                withdraw_address_id: element.withdraw_address_id
                            };
                            TempArrwith.push(withaddress);

                        });
                        setoriginal_withdrawaddress_array(TempArrwith);
                    }



                    if (res.data.withdrawtransaction.length > 0) {
                        let TempArrwith = [];
                        res.data.withdrawtransaction.forEach(element => {

                            let currancy = "";
                            let amount = "";
                            let status = "";

                            if (element.coin_code === "BTC") {
                                currancy = <div><img alt="" src={btcicon} className="coin-img" /></div>;
                                amount = element.withdraw_amount + " BTC";
                            } else if (element.coin_code === "ETH") {
                                currancy = <div><img alt="" src={ethicon} className="coin-img" /></div>;
                                amount = element.withdraw_amount + " ETH";
                            } else if (element.coin_code === "USDT") {
                                currancy = <div><img alt="" src={usdticon} className="coin-img" /></div>;
                                amount = element.withdraw_amount + " USDT";
                            } else if (element.coin_code === "USDC") {
                                currancy = <div><img alt="" src={usdcicon} className="coin-img" /></div>;
                                amount = element.withdraw_amount + " USDC";
                            }

                            if (element.withdraw_status === "Completed") {
                                status = <div><button className="btn btn-outline-success btn-rounded">Success</button></div>
                            } else if (element.withdraw_status === "Failed") {
                                status = <div><button className="btn btn-outline-danger btn-rounded">Failed</button></div>
                            } else {
                                status = <div><button className="btn btn-outline-warning btn-rounded">Pending</button></div>
                            }


                            let withtemp = {
                                date: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                                currancy: currancy,
                                transactionid: element.transaction_hash,
                                fees: element.tenpercnt,
                                transaction_fees: element.transaction_fees,
                                amount: element.withdraw_amount,
                                debitAmount: element.originalwithamount,
                                status: status,
                                StatusText: element.withdraw_status,
                                coincode: element.coin_code,
                                withdraw_tra_id: element.withdraw_tra_id
                            };
                            TempArrwith.push(withtemp);

                        });
                        setoriginal_withdraw_array(TempArrwith);
                    }

                    if (res.data.buyselltra.length > 0) {
                        let TempArrbuysell = [];
                        res.data.buyselltra.forEach(element => {

                            let status = "";
                            if (element.transfer_status === "Completed") {
                                status = <div><button onClick={() => handleOpenPopup(element)} className="btn btn-outline-success btn-rounded">Success</button></div>
                            } else if (element.transfer_status === "Failed") {
                                status = <div><button onClick={() => handleOpenPopup(element)} className="btn btn-outline-danger btn-rounded">Failed</button></div>
                            } else {
                                status = <div><button onClick={() => handleOpenPopup(element)} className="btn btn-outline-warning btn-rounded">Pending</button></div>
                            }

                            let currency = element.exchnage_pair.split("|");
                            let exchange_type = (parseFloat(element.admin_reward)).toFixed(8) +" "+ currency[0];
                            if(element.exchange_type=="Buy"){
                                exchange_type = (parseFloat(element.admin_reward)).toFixed(2) +" "+ currency[1];
                            }

                            let fiatonetemp = {
                                transaction_hash: element.transaction_hash,
                                created_datetime: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                                exchange_type: element.exchange_type,
                                exchnage_pair: element.exchnage_pair,
                                fee: exchange_type,
                                fiat_amount: formatBalance(element.fiat_amount),
                                crypto_amount: element.crypto_amount,
                                transfer_status: status,
                                StatusText: element.transfer_status,
                                exchange_id: element.exchange_id

                            };
                            TempArrbuysell.push(fiatonetemp);

                        });
                        setoriginal_exchange_array(TempArrbuysell);
                    }

                    if (res.data.swaptra.length > 0) {
                        let TempArrswap = [];
                        res.data.swaptra.forEach(element => {
                            let from_coin = "";
                            let to_coin = "";
                            let status = "";
                            if (element.swap_status === "Completed") {
                                status = <div><Link to="#" className="btn btn-outline-success btn-rounded">Success</Link></div>
                            } else if (element.swap_status === "Failed") {
                                status = <div><Link to="#" className="btn btn-outline-danger btn-rounded">Failed</Link></div>
                            } else {
                                status = <div><Link to="#" className="btn btn-outline-warning btn-rounded">Pending</Link></div>
                            }

                            if (element.coin_code === "BTC") {
                                from_coin = <div><img alt="" src={btcicon} className="coin-img" /></div>;
                            } else if (element.coin_code === "ETH") {
                                from_coin = <div><img alt="" src={ethicon} className="coin-img" /></div>;
                            } else if (element.coin_code === "USDT") {
                                from_coin = <div><img alt="" src={usdticon} className="coin-img" /></div>;
                            } else if (element.coin_code === "USDC") {
                                from_coin = <div><img alt="" src={usdcicon} className="coin-img" /></div>;
                            }

                            if (element.to_coin_code === "BTC") {
                                to_coin = <div><img alt="" src={btcicon} className="coin-img" /></div>;
                            } else if (element.to_coin_code === "ETH") {
                                to_coin = <div><img alt="" src={ethicon} className="coin-img" /></div>;
                            } else if (element.to_coin_code === "USDT") {
                                to_coin = <div><img alt="" src={usdticon} className="coin-img" /></div>;
                            } else if (element.to_coin_code === "USDC") {
                                to_coin = <div><img alt="" src={usdcicon} className="coin-img" /></div>;
                            }

                            let swaptemp = {
                                transaction_hash: element.transaction_hash,
                                created_datetime: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                                from_amount: element.from_amount+" "+element.coin_code,
                                from_coin: from_coin,
                                to_amount: element.to_amount+" "+element.to_coin_code,
                                to_coin: to_coin,
                                swap_status: status,
                                from_coincode: element.coin_code,
                                Fees: element.admin_reward +" "+element.coin_code,
                                to_coincode: element.to_coin_code,
                                StatusText: element.swap_status,
                                swap_id: element.swap_id,
                            };
                            TempArrswap.push(swaptemp);

                        });
                        setoriginal_swap_array(TempArrswap);
                    }

                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const [selectedExchangeRows, setSelectedExchangeRows] = useState([]);
    const [selectedWithdrawRows, setSelectedWithdrawRows] = useState([]);
    const [selectedSwapRows, setSelectedSwapRows] = useState([]);
    const [selectedDepositRows, setSelectedDepositRows] = useState([]);
    const [selectedTransferRows, setSelectedTransferRows] = useState([]);
    const [selectedDepositAddressRows, setSelectedDepositAddressRows] = useState([]);
    const [selectedWithdrawAddressRows, setSelectedWithdrawAddressRows] = useState([]);

    const handleRowSelection = (rowData, isChecked) => {
        switch (TransactionType) {
            case "CryptoExchange":
                if (isChecked) {
                    setSelectedExchangeRows(prev => [...prev, rowData]);
                } else {
                    setSelectedExchangeRows(prev => 
                        prev.filter(row => row.exchange_id !== rowData.exchange_id)
                    );
                }
                break;
            case "Withdrawal":
                if (isChecked) {
                    setSelectedWithdrawRows(prev => [...prev, rowData]);
                } else {
                    setSelectedWithdrawRows(prev => 
                        prev.filter(row => row.withdraw_tra_id !== rowData.withdraw_tra_id)
                    );
                }
                break;
            case "Swap":
                if (isChecked) {
                    setSelectedSwapRows(prev => [...prev, rowData]);
                } else {
                    setSelectedSwapRows(prev => 
                        prev.filter(row => row.swap_id !== rowData.swap_id)
                    );
                }
                break;
            case "Deposit":
                if (isChecked) {
                    setSelectedDepositRows(prev => [...prev, rowData]);
                } else {
                    setSelectedDepositRows(prev => 
                        prev.filter(row => row.depositfund_id !== rowData.depositfund_id)
                    );
                }
                break;
            case "Transfer":
                if (isChecked) {
                    setSelectedTransferRows(prev => [...prev, rowData]);
                } else {
                    setSelectedTransferRows(prev => 
                        prev.filter(row => row.transfer_id !== rowData.transfer_id)
                    );
                }
                break;
            case "Depositaddress":
                if (isChecked) {
                    setSelectedDepositAddressRows(prev => [...prev, rowData]);
                } else {
                    setSelectedDepositAddressRows(prev => 
                        prev.filter(row => row.deposit_address_id !== rowData.deposit_address_id)
                    );
                }
                break;
            case "Withdrawaddress":
                if (isChecked) {
                    setSelectedWithdrawAddressRows(prev => [...prev, rowData]);
                } else {
                    setSelectedWithdrawAddressRows(prev => 
                        prev.filter(row => row.withdraw_address_id !== rowData.withdraw_address_id)
                    );
                }
                break;
            default:
                console.warn(`Unexpected transaction type: ${TransactionType}`);
                break;
        }
    };

    // Function to handle "select all" checkbox
    const handleSelectAll = (isChecked) => {
        switch (TransactionType) {
            case "CryptoExchange":
                if (isChecked) {
                    setSelectedExchangeRows([...original_exchange_array]);
                } else {
                    setSelectedExchangeRows([]);
                }
                break;
            case "Withdrawal":
                if (isChecked) {
                    setSelectedWithdrawRows([...original_withdraw_array]);
                } else {
                    setSelectedWithdrawRows([]);
                }
                break;
            case "Swap":
                if (isChecked) {
                    setSelectedSwapRows([...original_swap_array]);
                } else {
                    setSelectedSwapRows([]);
                }
                break;
            case "Deposit":
                if (isChecked) {
                    setSelectedDepositRows([...original_deposit_array]);
                } else {
                    setSelectedDepositRows([]);
                }
                break;
            case "Transfer":
                if (isChecked) {
                    setSelectedTransferRows([...original_transfer_array]);
                } else {
                    setSelectedTransferRows([]);
                }
                break;
            case "Depositaddress":
                if (isChecked) {
                    setSelectedDepositAddressRows([...original_depositaddress_array]);
                } else {
                    setSelectedDepositAddressRows([]);
                }
                break;
            case "Withdrawaddress":
                if (isChecked) {
                    setSelectedWithdrawAddressRows([...original_withdrawaddress_array]);
                } else {
                    setSelectedWithdrawAddressRows([]);
                }
                break;
            default:
                console.warn(`Unexpected transaction type: ${TransactionType}`);
                break;
        }
    };

    // Function to check if a row is selected
    const isRowSelected = (rowData) => {
        switch (TransactionType) {
            case "CryptoExchange":
                return selectedExchangeRows.some(row => row.exchange_id === rowData.exchange_id);
            case "Withdrawal":
                return selectedWithdrawRows.some(row => row.withdraw_tra_id === rowData.withdraw_tra_id);
            case "Swap":
                return selectedSwapRows.some(row => row.swap_id === rowData.swap_id);
            case "Deposit":
                return selectedDepositRows.some(row => row.depositfund_id === rowData.depositfund_id);
            case "Transfer":
                return selectedTransferRows.some(row => row.transfer_id === rowData.transfer_id);
            case "Depositaddress":
                return selectedDepositAddressRows.some(row => row.deposit_address_id === rowData.deposit_address_id);
            case "Withdrawaddress":
                return selectedWithdrawAddressRows.some(row => row.withdraw_address_id === rowData.withdraw_address_id);
            default:
                return false;
        }
    };

    // Function to check if all rows are selected
    const isAllSelected = () => {
        switch (TransactionType) {
            case "CryptoExchange":
                return original_exchange_array.length > 0 && 
                    selectedExchangeRows.length === original_exchange_array.length;
            case "Withdrawal":
                return original_withdraw_array.length > 0 && 
                    selectedWithdrawRows.length === original_withdraw_array.length;
            case "Swap":
                return original_swap_array.length > 0 && 
                    selectedSwapRows.length === original_swap_array.length;
            case "Deposit":
                return original_deposit_array.length > 0 && 
                    selectedDepositRows.length === original_deposit_array.length;
            case "Transfer":
                return original_transfer_array.length > 0 && 
                    selectedTransferRows.length === original_transfer_array.length;
            case "Depositaddress":
                return original_depositaddress_array.length > 0 && 
                    selectedDepositAddressRows.length === original_depositaddress_array.length;
            case "Withdrawaddress":
                return original_withdrawaddress_array.length > 0 && 
                    selectedWithdrawAddressRows.length === original_withdrawaddress_array.length;
            default:
                return false;
        }
    };

    const validateFromdate = (value) => {
        setfrom_date(value);
        
        // Clear selections based on current transaction type
        switch (TransactionType) {
            case "CryptoExchange":
                setSelectedExchangeRows([]);
                break;
            case "Withdrawal":
                setSelectedWithdrawRows([]);
                break;
            case "Swap":
                setSelectedSwapRows([]);
                break;
            case "Deposit":
                setSelectedDepositRows([]);
                break;
            case "Transfer":
                setSelectedTransferRows([]);
                break;
            case "Depositaddress":
                setSelectedDepositAddressRows([]);
                break;
            case "Withdrawaddress":
                setSelectedWithdrawAddressRows([]);
                break;
            default:
                console.warn(`Unexpected transaction type: ${TransactionType}`);
                break;
        }
        
        filter("1," + value, "");
    }

    const validateTodate = (value) => {
        setto_date(value);
        
        // Clear selections based on current transaction type
        switch (TransactionType) {
            case "CryptoExchange":
                setSelectedExchangeRows([]);
                break;
            case "Withdrawal":
                setSelectedWithdrawRows([]);
                break;
            case "Swap":
                setSelectedSwapRows([]);
                break;
            case "Deposit":
                setSelectedDepositRows([]);
                break;
            case "Transfer":
                setSelectedTransferRows([]);
                break;
            case "Depositaddress":
                setSelectedDepositAddressRows([]);
                break;
            case "Withdrawaddress":
                setSelectedWithdrawAddressRows([]);
                break;
            default:
                console.warn(`Unexpected transaction type: ${TransactionType}`);
                break;
        }
        
        filter("", "1," + value);
    }


    const filter = (fromdate = "", todate = "") => {
        let tempfrom = from_date;
        let temptodate = to_date;

        if (fromdate !== "") {
            if (fromdate.split(",")[0] === "1" && fromdate.split(",")[1] !== "") {
                tempfrom = fromdate.split(",")[1];
            }
            else if (fromdate.split(",")[0] === "1" && fromdate.split(",")[1] === "") {
                tempfrom = "";
            }
        }

        if (todate !== "") {
            if (todate.split(",")[0] === "1" && todate.split(",")[1] !== "") {
                temptodate = todate.split(",")[1];
            }
            else if (todate.split(",")[0] === "1" && todate.split(",")[1] === "") {
                temptodate = "";
            }
        }

        if (TransactionType === "Withdrawal") {
            let TempArr = [];
            temp_withdraw_array.forEach(element => {
                let currancy = "";
                let amount = "";
                let status = "";

                if (element.coin_code === "BTC") {
                    currancy = <div><img alt="" src={btcicon} className="coin-img" /></div>;
                    amount = element.withdraw_amount + " BTC";
                } else if (element.coin_code === "ETH") {
                    currancy = <div><img alt="" src={ethicon} className="coin-img" /></div>;
                    amount = element.withdraw_amount + " ETH";
                } else if (element.coin_code === "USDT") {
                    currancy = <div><img alt="" src={usdticon} className="coin-img" /></div>;
                    amount = element.withdraw_amount + " USDT";
                } else if (element.coin_code === "USDC") {
                    currancy = <div><img alt="" src={usdcicon} className="coin-img" /></div>;
                    amount = element.withdraw_amount + " USDC";
                }

                if (element.withdraw_status === "Completed") {
                    status = <div><button className="btn btn-outline-success btn-rounded">Success</button></div>
                } else if (element.withdraw_status === "Failed") {
                    status = <div><button className="btn btn-outline-danger btn-rounded">Failed</button></div>
                } else {
                    status = <div><button className="btn btn-outline-warning btn-rounded">Pending</button></div>
                }


                let temp = {
                    date: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                    currancy: currancy,
                    transactionid: element.transaction_hash,
                    fees: element.tenpercnt,
                    transaction_fees: element.transaction_fees,
                    amount: element.withdraw_amount,
                    debitAmount: element.originalwithamount,
                    status: status,
                    withdraw_tra_id: element.withdraw_tra_id
                };


                if (tempfrom === "" && temptodate === "") {
                    TempArr.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && temptodate === "") {
                    TempArr.push(temp);
                }
                else if (tempfrom === "" && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArr.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArr.push(temp);
                }
            });
            setoriginal_withdraw_array(TempArr);
        } else if (TransactionType === "Deposit") {
            let TempArr = [];
            temp_deposit_array.forEach(element => {
                let currancy = "";
                let amount = "";
                let status = "";

                if (element.coin_code === "BTC") {
                    currancy = <div><img alt="" src={btcicon} className="coin-img" /></div>;
                    amount = element.fund_amount ;
                } else if (element.coin_code === "ETH") {
                    currancy = <div><img alt="" src={ethicon} className="coin-img" /></div>;
                    amount = element.fund_amount ;
                } else if (element.coin_code === "USDT") {
                    currancy = <div><img alt="" src={usdticon} className="coin-img" /></div>;
                    amount = element.fund_amount ;
                } else if (element.coin_code === "USDC") {
                    currancy = <div><img alt="" src={usdcicon} className="coin-img" /></div>;
                    amount = element.fund_amount ;
                }

                if (element.deposit_status === "Completed") {
                    status = <div><button className="btn btn-outline-success btn-rounded">Success</button></div>
                } else if (element.deposit_status === "Failed") {
                    status = <div><button className="btn btn-outline-danger btn-rounded">Failed</button></div>
                } else {
                    status = <div><button className="btn btn-outline-warning btn-rounded">Pending</button></div>
                }


                let temp = {
                    date: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                    currancy: currancy,
                    transactionid: element.transaction_hash,
                    amount: formatBalance(amount)+" "+ element.coin_code,
                    status: status,
                    depositfund_id: element.depositfund_id
                };


                if (tempfrom === "" && temptodate === "") {
                    TempArr.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && temptodate === "") {
                    TempArr.push(temp);
                }
                else if (tempfrom === "" && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArr.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArr.push(temp);
                }
            });
            setoriginal_deposit_array(TempArr);
        } else if (TransactionType === "Depositaddress") {
            let TempArr = [];
            temp_depositaddress_array.forEach(element => {
                let status;
                if (element.status === "Approved") {
                    status = <div><button className="btn btn-outline-warning btn-rounded">Inactive</button></div>
                } else {
                    status = <div><button className="btn btn-outline-success btn-rounded">Active</button></div>
                }

                let temp = {
                    date: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                    Accountno: element.user_acc_account_number,
                    WalletAddress: element.wallet_address,
                    Status: status,
                    Action: <Link to="#" onClick={() => viewdeposit(element)} className="btn btn-light btn-rounded btn-xs" title="View"><i className="fa fa-eye f-18"></i></Link>,
                    deposit_address_id: element.deposit_address_id
                };


                if (tempfrom === "" && temptodate === "") {
                    TempArr.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && temptodate === "") {
                    TempArr.push(temp);
                }
                else if (tempfrom === "" && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArr.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArr.push(temp);
                }
            });
            setoriginal_depositaddress_array(TempArr);
        } else if (TransactionType === "Withdrawaddress") {
            let TempArr = [];
            temp_withdrawaddress_array.forEach(element => {
                let status = <div><button className="btn btn-outline-warning btn-rounded">Inactive</button></div>


                let temp = {
                    date: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                    Accountno: element.user_acc_account_number,
                    WalletAddress: element.wallet_address,
                    Status: status,
                    Action: <Link to="#" onClick={() => viewdeposit(element)} className="btn btn-light btn-rounded btn-xs" title="View"><i className="fa fa-eye f-18"></i></Link>,
                    withdraw_address_id: element.withdraw_address_id
                };

                if (tempfrom === "" && temptodate === "") {
                    TempArr.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && temptodate === "") {
                    TempArr.push(temp);
                }
                else if (tempfrom === "" && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArr.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArr.push(temp);
                }
            });
            setoriginal_withdrawaddress_array(TempArr);
        } else if (TransactionType === "Transfer") {
            let TempArrss = [];
            temp_transfer_array.forEach(element => {
                let currancy = "";
                let amount = "";

                let userdiv = <div><div className="mb-lg-0 mb-3 d-flex align-items-center"><div className="profile-image mr-4"><img src={avarta} alt="" width="63" className="rounded-circle" /></div><div><h6 className="fs-16 font-w700 mb-0"><Link to="#" className="text-black"> {element.first_name + '' + element.last_name}</Link></h6><span className="fs-14">{element.email_id}</span></div></div></div>
                if (element.image_64 !== "" && element.image_64 !== null) {
                    userdiv = <div><div className="mb-lg-0 mb-3 d-flex align-items-center"><div className="profile-image mr-4"><img src={process.env.REACT_APP_FILE_PATH + element.image_64} alt="" width="63" className="rounded-circle" /></div><div><h6 className="fs-16 font-w700 mb-0"><Link to="#" className="text-black"> {element.first_name + ' ' + element.last_name}</Link></h6><span className="fs-14">{element.email_id}</span></div></div></div>
                }
                if (element.coin_code === "BTC") {
                    currancy = <div><img alt="" src={btcicon} className="coin-img" /></div>;
                    amount = element.transfer_amount + " BTC";
                } else if (element.coin_code === "ETH") {
                    currancy = <div><img alt="" src={ethicon} className="coin-img" /></div>;
                    amount = element.transfer_amount + " ETH";
                } else if (element.coin_code === "USDT") {
                    currancy = <div><img alt="" src={usdticon} className="coin-img" /></div>;
                    amount = element.transfer_amount + " USDT";
                } else if (element.coin_code === "USDC") {
                    currancy = <div><img alt="" src={usdcicon} className="coin-img" /></div>;
                    amount = element.transfer_amount + " USDC";
                }

                let temp = {
                    userdiv: userdiv,
                    transactionid: element.transaction_hash,
                    date: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                    currancy: currancy,
                    amount: amount,
                    transfer_id: element.transfer_id
                };

                if (tempfrom === "" && temptodate === "") {
                    TempArrss.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && temptodate === "") {
                    TempArrss.push(temp);
                }
                else if (tempfrom === "" && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArrss.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    TempArrss.push(temp);
                }
            });
            setoriginal_transfer_array(TempArrss);
        } else if (TransactionType === "CryptoExchange") {
            let Tempexchange = [];
            temp_exchange_array.forEach(element => {
                let status = "";
                if (element.transfer_status === "Completed") {
                    status = <div><button onClick={() => handleOpenPopup(element)} className="btn btn-outline-success btn-rounded">Success</button></div>
                } else if (element.transfer_status === "Failed") {
                    status = <div><button onClick={() => handleOpenPopup(element)} className="btn btn-outline-danger btn-rounded">Failed</button></div>
                } else {
                    status = <div><button onClick={() => handleOpenPopup(element)} className="btn btn-outline-warning btn-rounded">Pending</button></div>
                }
                let temp = {
                    transaction_hash: element.transaction_hash,
                    created_datetime: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                    exchange_type: element.exchange_type,
                    exchnage_pair: element.exchnage_pair,
                    fee: formatBalance(element.admin_reward),
                    fiat_amount: formatBalance(element.fiat_amount),
                    crypto_amount: element.crypto_amount,
                    transfer_status: status,
                    exchange_id: element.exchange_id
                };

                if (tempfrom === "" && temptodate === "") {
                    Tempexchange.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && temptodate === "") {
                    Tempexchange.push(temp);
                }
                else if (tempfrom === "" && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    Tempexchange.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    Tempexchange.push(temp);
                }
            });
            setoriginal_exchange_array(Tempexchange);
        } else if (TransactionType === "Swap") {
            let Tempswap = [];
            temp_swap_array.forEach(element => {
                let from_coin = "";
                let to_coin = "";
                let status = "";
                if (element.swap_status === "Completed") {
                    status = <div><Link to="#" className="btn btn-outline-success btn-rounded">Success</Link></div>
                } else if (element.swap_status === "Failed") {
                    status = <div><Link to="#" className="btn btn-outline-danger btn-rounded">Failed</Link></div>
                } else {
                    status = <div><Link to="#" className="btn btn-outline-warning btn-rounded">Pending</Link></div>
                }

                if (element.coin_code === "BTC") {
                    from_coin = <div><img alt="" src={btcicon} className="coin-img" /></div>;
                } else if (element.coin_code === "ETH") {
                    from_coin = <div><img alt="" src={ethicon} className="coin-img" /></div>;
                } else if (element.coin_code === "USDT") {
                    from_coin = <div><img alt="" src={usdticon} className="coin-img" /></div>;
                } else if (element.coin_code === "USDC") {
                    from_coin = <div><img alt="" src={usdcicon} className="coin-img" /></div>;
                }

                if (element.to_coin_code === "BTC") {
                    to_coin = <div><img alt="" src={btcicon} className="coin-img" /></div>;
                } else if (element.to_coin_code === "ETH") {
                    to_coin = <div><img alt="" src={ethicon} className="coin-img" /></div>;
                } else if (element.to_coin_code === "USDT") {
                    to_coin = <div><img alt="" src={usdticon} className="coin-img" /></div>;
                } else if (element.coin_code === "USDC") {
                    from_coin = <div><img alt="" src={usdcicon} className="coin-img" /></div>;
                }

                let temp = {
                    transaction_hash: element.transaction_hash,
                    created_datetime: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                    from_amount: formatBalance(element.from_amount),
                    from_coin: from_coin,
                    to_amount: formatBalance(element.to_amount),
                    to_coin: to_coin,
                    swap_status: status,
                    swap_id: element.swap_id,
                };

                if (tempfrom === "" && temptodate === "") {
                    Tempswap.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && temptodate === "") {
                    Tempswap.push(temp);
                }
                else if (tempfrom === "" && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    Tempswap.push(temp);
                }
                else if ((tempfrom !== "" && moment(element.created_datetime).format('YYYY-MM-DD') >= moment(tempfrom).format('YYYY-MM-DD')) && (temptodate !== "" && moment(element.created_datetime).format('YYYY-MM-DD') <= moment(temptodate).format('YYYY-MM-DD'))) {
                    Tempswap.push(temp);
                }
            });
            setoriginal_swap_array(Tempswap);
        }
    }

    return (
        <div>
            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <div className="card bg-0 bg-none">
                    <div className="card-header page-title-space mobile-card-header">
                        <h2 className="text-black font-w500 mb-0">{t("CRYPTOTRANSACTION.CRYPTO_TRA_LABEL")}</h2>
                        <div className="mobileFullWidth">
                            <Dropdown className="custom-dropdown mb-0" >
                                <Dropdown.Toggle className="btn btn-primary btn-rounded i-false" variant='' >
                                    <i className="las la-download scale5 mr-3"></i> Download Report
                                    <i className="fa fa-caret-down text-white ml-3" aria-hidden="true"></i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu-right right-cstm">
                                    <Dropdown.Item className="" onClick={(e) => handleChangeCSVNdPDF("CSV")}>CSV</Dropdown.Item>
                                    <Dropdown.Item className="" onClick={(e) => handleChangeCSVNdPDF("PDF")}>PDF</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            }
            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <div className="card mb-0 p-0">
                    <div className="card-body bdr-btm-card">
                        <div className="row">

                            <div className="col-md-4">
                                <div className="form-group position-relative">
                                    <label className="mb-2 ">
                                        <span>{t('TRANSACTION.FROM_DATE')}</span>
                                    </label>
                                    <div className="col-xs-12">
                                        <input type="date" onChange={(e) => validateFromdate(e.target.value)} value={from_date} className="form-control" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="form-group position-relative">
                                    <label className="mb-2 ">
                                        <span>{t('TRANSACTION.TO_DATE')}</span>
                                    </label>
                                    <div className="col-xs-12">
                                        <input type="date" onChange={(e) => validateTodate(e.target.value)} value={to_date} className="form-control" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="form-group position-relative">
                                    <label className="mb-2 ">
                                        <span>{t("TRANSACTION.TRANSACTION_TYPE")}</span>
                                    </label>
                                    <select className="form-control webkit-none" value={TransactionType} onChange={(event) => handleChangeTransactionType(event.target.value)}>
                                        <option value={"CryptoExchange"}>{t("CRYPTOTRANSACTION.CRYPTO_EX_LABEL")}</option>
                                        {/* <option value={"Deposit"}>{t("CRYPTOTRANSACTION.DEPOSIT_TITLE")}</option>
                                        <option value={"Depositaddress"}>Deposit Address</option>
                                        <option value={"Withdrawaddress"}>Withdraw Address</option> */}
                                        <option value={"Withdrawal"}>{t("CRYPTOTRANSACTION.WITHDRAW_TITLE")}</option>
                                        {/* <option value={"Transfer"}>{t("CRYPTOTRANSACTION.TRANSFER_TITLE")}</option> */}
                                        <option value={"Swap"}>{t("CRYPTOTRANSACTION.SWAP_TITLE")}</option>
                                    </select>
                                    <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="card-body">
                        <div className="mobileFullWidth">
                            {/* <Dropdown className="custom-dropdown mb-0" >
                                <Dropdown.Toggle className="btn btn-primary btn-rounded i-false" variant='' >
                                    <i className="las la-download scale5 mr-3"></i> Download Report
                                    <i className="fa fa-caret-down text-white ml-3" aria-hidden="true"></i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu-right right-cstm">
                                    <Dropdown.Item className="" onClick={(e) => handleChangeCSVNdPDF("CSV")}>CSV</Dropdown.Item>
                                    <Dropdown.Item className="" onClick={(e) => handleChangeCSVNdPDF("PDF")}>PDF</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown> */}
                        </div>
                        <div className="position-relative hide-scrolllbar">
                            <div className="table-responsive" id="CryptoExchange">
                                {original_exchange_array.length > 0 ?
                                    <MaterialTable
                                        title={t("TRANSACTION.BUYSELLLA")}
                                        icons={materialTableIcons}
                                        options={{ exportButton: false, paging: true, pageSize: 5, pageSizeOptions: [5, 10, 15], emptyRowsWhenPaging: false, }}
                                        columns={[
                                            { title: (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isAllSelected()}
                                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                                        />
                                                    </div>
                                                ),
                                                field: 'selection',
                                                width: '50px',
                                                sorting: false, // Disable sorting for checkbox column
                                                render: rowData => (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isRowSelected(rowData)}
                                                            onChange={(e) => handleRowSelection(rowData, e.target.checked)}
                                                        />
                                                    </div>
                                                )
                                            },
                                            { title: t("TRANSACTION.TRA_ID"), field: 'transaction_hash', },
                                            { title: t("TRANSACTION.DATE_LA"), field: 'created_datetime',
                                                render: rowData => (
                                                    <div>
                                                        {moment(rowData.created_datetime).format('MMMM D, YYYY')} <br />
                                                        {moment(rowData.created_datetime).format('hh:mm:ss A')}
                                                    </div>
                                                )
                                            },
                                            { title: t("TRANSACTION.TYPE"), field: 'exchange_type' },
                                            { title: t("TRANSACTION.PAIR"), field: 'exchnage_pair', },
                                            { title: "Crypto Amount", field: 'crypto_amount',align: 'right'},
                                            { title: t("TRANSACTION.FIAT_AMOUNT"), field: 'fiat_amount',align: 'right',cellStyle: { minWidth: 180 },headerStyle: { minWidth: 180 }},
                                            { title: "Site Fee", field: 'fee', },
                                            { title: t("TRANSACTION.STATUS_LA"), field: 'transfer_status' },
                                        ]}
                                        data={original_exchange_array}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">{t("TRANSACTION.BUYSELLLA")} Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                            </div>

                            <div className="table-responsive" id="Deposit" style={{ display: "none" }}>
                                {original_deposit_array.length > 0 ?
                                    <MaterialTable
                                        title="Deposit"
                                        icons={materialTableIcons}
                                        options={{ exportButton: false, paging: true, pageSize: 5, pageSizeOptions: [5, 10, 15], emptyRowsWhenPaging: false, size: 'medium' }}
                                        columns={[
                                            { title: (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isAllSelected()}
                                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                                        />
                                                    </div>
                                                ),
                                                field: 'selection',
                                                width: '50px',
                                                sorting: false,
                                                render: rowData => (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isRowSelected(rowData)}
                                                            onChange={(e) => handleRowSelection(rowData, e.target.checked)}
                                                        />
                                                    </div>
                                                )
                                            },
                                            { title: t("TRANSACTION.DATE_LA"), field: 'date' },
                                            { title: t("CRYPTOTRANSACTION.COINCODE"), field: 'currancy' },
                                            { title: t("CRYPTOTRANSACTION.TRAHASH"), field: 'transactionid' },
                                            { title: t("TRANSACTION.AMOUNT"), field: 'amount' },
                                            { title: t("TRANSACTION.STATUS_LA"), field: 'status', align: 'center' }
                                        ]}
                                        data={original_deposit_array}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">Deposit Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                            </div>
                            <div className="table-responsive" id="Depositaddress" style={{ display: "none" }}>
                                {original_depositaddress_array.length > 0 ?
                                    <MaterialTable
                                        title="Deposit Address"
                                        icons={materialTableIcons}
                                        options={{ exportButton: false, paging: true, pageSize: 5, pageSizeOptions: [5, 10, 15], emptyRowsWhenPaging: false, size: 'medium' }}
                                        columns={[
                                            { title: (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isAllSelected()}
                                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                                        />
                                                    </div>
                                                ),
                                                field: 'selection',
                                                width: '50px',
                                                sorting: false,
                                                render: rowData => (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isRowSelected(rowData)}
                                                            onChange={(e) => handleRowSelection(rowData, e.target.checked)}
                                                        />
                                                    </div>
                                                )
                                            },
                                            { title: 'Date', field: 'date', 
                                                render: rowData => (
                                                                                                    <div>
                                                                                                        {moment(rowData.date).format('MMMM D, YYYY')} <br />
                                                                                                        {moment(rowData.date).format('hh:mm:ss A')}
                                                                                                    </div>
                                                                                                )
                                            },
                                            { title: 'Account Number', field: 'Accountno' },
                                            { title: 'Wallet Address', field: 'WalletAddress' },
                                            { title: 'Status', field: 'Status', align: 'center' },
                                            { title: 'Action', field: 'Action', align: 'center' },
                                        ]}
                                        data={original_depositaddress_array}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">Deposit Address Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                            </div>
                            <div className="table-responsive" id="Withdrawaddress" style={{ display: "none" }}>
                                {original_withdrawaddress_array.length > 0 ?
                                    <MaterialTable
                                        title="Withdraw Address"
                                        icons={materialTableIcons}
                                        options={{ exportButton: false, paging: true, pageSize: 5, pageSizeOptions: [5, 10, 15], emptyRowsWhenPaging: false, size: 'medium' }}
                                        columns={[
                                            { title: (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isAllSelected()}
                                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                                        />
                                                    </div>
                                                ),
                                                field: 'selection',
                                                width: '50px',
                                                sorting: false,
                                                render: rowData => (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isRowSelected(rowData)}
                                                            onChange={(e) => handleRowSelection(rowData, e.target.checked)}
                                                        />
                                                    </div>
                                                )
                                            },
                                            { title: 'Date', field: 'date',
                                                render: rowData => (
                                                        <div>
                                                            {moment(rowData.date).format('MMMM D, YYYY')} <br />
                                                            {moment(rowData.date).format('hh:mm:ss A')}
                                                        </div>
                                                    )
                                             },
                                            { title: 'Account Number', field: 'Accountno' },
                                            { title: 'Wallet Address', field: 'WalletAddress' },
                                            { title: 'Status', field: 'Status', align: 'center' },
                                            { title: 'Action', field: 'Action' },
                                        ]}
                                        data={original_withdrawaddress_array}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">Withdraw Address Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                            </div>
                            <div className="table-responsive" id="Withdrawal" style={{ display: "none" }}>
                                {original_withdraw_array.length > 0 ?
                                    <MaterialTable
                                        title={t("TRANSACTION.WITHTRALA")}
                                        icons={materialTableIcons}
                                        options={{ exportButton: false, paging: true, pageSize: 5, pageSizeOptions: [5, 10, 15], emptyRowsWhenPaging: false, size: 'medium' }}
                                        columns={[
                                            { title: (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isAllSelected()}
                                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                                        />
                                                    </div>
                                                ),
                                                field: 'selection',
                                                width: '50px',
                                                sorting: false,
                                                render: rowData => (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isRowSelected(rowData)}
                                                            onChange={(e) => handleRowSelection(rowData, e.target.checked)}
                                                        />
                                                    </div>
                                                )
                                            },
                                            { title: t("TRANSACTION.DATE_LA"), field: 'date',
                                                render: rowData => (
                                                    <div>
                                                        {moment(rowData.date).format('MMMM D, YYYY')} <br />
                                                        {moment(rowData.date).format('hh:mm:ss A')}
                                                    </div>
                                                )
                                             },
                                            { title: t("CRYPTOTRANSACTION.COINCODE"), field: 'currancy' },
                                            { title: t("CRYPTOTRANSACTION.TRAHASH"), field: 'transactionid' },
                                            { title: t("TRANSACTION.AMOUNT"), field: 'amount' },
                                            { title: "Order Amount", field: 'debitAmount' },
                                            { title: "Site Fee", field: 'fees' },
                                            { title: "Network Fees", field: 'transaction_fees' },
                                            { title: t("TRANSACTION.STATUS_LA"), field: 'status', align: 'center' }
                                        ]}
                                        data={original_withdraw_array}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">{t("TRANSACTION.WITHTRALA")} Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                            </div>
                            <div className="table-responsive" id="Transfer" style={{ display: "none" }}>
                                {original_transfer_array.length > 0 ?
                                    <MaterialTable
                                        title={t("TRANSACTION.TRANSFERTRALA")}
                                        icons={materialTableIcons}
                                        options={{ exportButton: false, paging: true, pageSize: 5, pageSizeOptions: [5, 10, 15], emptyRowsWhenPaging: false, size: 'medium' }}
                                        columns={[
                                            { title: (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isAllSelected()}
                                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                                        />
                                                    </div>
                                                ),
                                                field: 'selection',
                                                width: '50px',
                                                sorting: false,
                                                render: rowData => (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isRowSelected(rowData)}
                                                            onChange={(e) => handleRowSelection(rowData, e.target.checked)}
                                                        />
                                                    </div>
                                                )
                                            },
                                            { title: t("TRANSACTION.USERNAME"), field: 'userdiv' },
                                            { title: t("CRYPTOTRANSACTION.TRAHASH"), field: 'transactionid' },
                                            { title: t("TRANSACTION.DATE_LA"), field: 'date' ,
                                                render: rowData => (
                                                            <div>
                                                                {moment(rowData.date).format('MMMM D, YYYY')} <br />
                                                                {moment(rowData.date).format('hh:mm:ss A')}
                                                            </div>
                                                        )
                                            },
                                            { title: t("CRYPTOTRANSACTION.COINCODE"), field: 'currancy' },
                                            { title: t("TRANSACTION.AMOUNT"), field: 'amount' }
                                        ]}
                                        data={original_transfer_array}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">{t("TRANSACTION.TRANSFERTRALA")} Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                            </div>
                            <div className="table-responsive" id="Swap" style={{ display: "none" }}>
                                {original_swap_array.length > 0 ?
                                    <MaterialTable
                                        title={t("TRANSACTION.SWAP_TRA_LA")}
                                        icons={materialTableIcons}
                                        options={{ exportButton: false, paging: true, pageSize: 5, pageSizeOptions: [5, 10, 15], emptyRowsWhenPaging: false, }}
                                        columns={[
                                            { title: (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isAllSelected()}
                                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                                        />
                                                    </div>
                                                ),
                                                field: 'selection',
                                                width: '50px',
                                                sorting: false,
                                                render: rowData => (
                                                    <div style={{ textAlign: 'center', width: '100%', marginLeft: '10px' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isRowSelected(rowData)}
                                                            onChange={(e) => handleRowSelection(rowData, e.target.checked)}
                                                        />
                                                    </div>
                                                )
                                            },
                                            { title: t("TRANSACTION.TRA_ID"), field: 'transaction_hash', },
                                            { title: t("TRANSACTION.DATE_LA"), field: 'created_datetime' ,
                                                render: rowData => (
                                                        <div>
                                                            {moment(rowData.created_datetime).format('MMMM D, YYYY')} <br />
                                                            {moment(rowData.created_datetime).format('hh:mm:ss A')}
                                                        </div>
                                                    )
                                            },
                                            { title: t("FIAT.FROM_AMOUNT"), field: 'from_amount' ,align: 'right'},
                                            // { title: t("FIAT.FROM"), field: 'from_coin' },
                                            { title: t("FIAT.TO_AMOUNT"), field: 'to_amount',align: 'right'},
                                            { title: "Site Fee", field: 'Fees',align: 'right'},
                                            // { title: t("FIAT.TO"), field: 'to_coin' },
                                            { title: t("TRANSACTION.STATUS_LA"), field: 'swap_status' },
                                        ]}
                                        data={original_swap_array}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">{t("TRANSACTION.SWAP_TRA_LA")} Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                            </div>
                        </div>
                    </div>

                </div>
            }
            <Modal className='modal fade' show={open} onHide={handleClosePopup}>
                <div className='modal-dialog modal-dialog-centered'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h3 className='modal-title'>Transaction Details</h3>
                            <button type='button' className='close' onClick={handleClosePopup}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className='modal-body'>
                            {selectedTransaction && (
                                <div className='row'>
                                    <div className='col-md-6 mb-3'>
                                        <strong>Transaction ID:</strong> {selectedTransaction.transaction_hash}
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <strong>Type:</strong> {selectedTransaction.exchange_type}
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <strong>Date:</strong> {moment(selectedTransaction.created_datetime).format('MMMM D, YYYY hh:mm:ss')}
                                    </div>
                                    {selectedTransaction.exchnage_pair ? (
                                    <>
									<div className='col-md-6 mb-3'>
                                    <strong>Status:</strong> {selectedTransaction.transfer_status} 
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <strong>Fiat:</strong> {`${Number(selectedTransaction.fiat_amount).toFixed(2)} ${selectedTransaction.exchnage_pair.split("|")[1]}`} 
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                    <strong>Crypto:</strong> {`${parseFloat(selectedTransaction.crypto_amount)} ${selectedTransaction.exchnage_pair.split("|")[0]}`} 
                                    </div>
									
                                    </>
                                    ) : ""}
									{selectedTransaction.transfer_status=="Completed"?
									<div className='col-md-6 mb-3'>
                                    <strong>Transaction Hash:</strong> {selectedTransaction.admin_transaction_hash} 
                                    </div>
									:""}

									{selectedTransaction.transfer_status!=="Pending"?

									<div className='col-md-12 mb-3'>
                                    <strong>Admin Comment:</strong> {selectedTransaction.admin_note}
                                    </div>
									:""}
                                </div>
                            )}
                        </div>
                        
                    </div>
                </div>
            </Modal>
        </div>
    )

}
export default Crypto_Transactions;